// @flow
import styled from 'styled-components';

export const TopHero = styled.div`
  background-color: #8ec5fc;
  background-image: linear-gradient(62deg, #8ec5fc 0%, #e0c3fc 100%);
  color: white;
  padding: 20px 0;
`;

export const ContentWithPadding = styled.div`
  padding: ${props => (props.py ? `${props.py}px 0` : '0')};
`;

export const SectionBlock = styled.section`
  padding: 48px 0;
`;

export const OverlappingSectionBlock = styled.div`
  position: relative;
  top: ${props => `${props.offset}px` || ''};
`;

export const ResultsWrapper = styled.div`
  margin-right: -16px;
  margin-left: -16px;
  margin-top: 8px;

  @media (min-width: 600px) {
    margin-right: 0;
    margin-left: 0;
  }
`;
